export default "__VITE_ASSET__d63c7fa4__"